import { render } from "./TermsConditions.vue?vue&type=template&id=7b5a0eb0&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./custom-terms-conditions.scss?vue&type=style&index=0&id=7b5a0eb0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5a0eb0"]])

export default __exports__